import {gql} from '@apollo/client';

// Runtime source of truth for which tabs exist and which sub-tabs each tab has.
// The role builder reads its tab / sub-tab options from this catalog instead of
// the static ADMIN_TAB_FIELDS constant. Returned data is already sorted
// alphabetically by label, server-side.
export const GET_ADMIN_DASHBOARD_MENU = gql`
  query GetAdminDashboardMenu {
    getAdminDashboardMenu {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminDashboardMenu {
        message
        data {
          id
          key
          label
          subTabs {
            key
            label
          }
        }
      }
    }
  }
`;
